import { Model } from 'modules/core/lib/mobx-rest'

interface ITerminationType {
  [key: string]: any
}

class TerminationType extends Model<ITerminationType> {
  static urlRoot() {
    return '/api/rest/contracts/termination_type'
  }
}

export default TerminationType
